import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { doc, Firestore, getDoc } from '@angular/fire/firestore';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Notice } from '../../../../models/notice.model';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import { BtnBackComponent } from '../../../components/buttons/btn-back/btn-back.component';
import { BtnIconComponent } from '../../../components/buttons/btn-icon/btn-icon.component';
import { LoadingDotsComponent } from '../../../components/spinners/loading-dots/loading-dots.component';
import { TimeBeforeComponent } from '../../../components/time/time-before/time-before.component';

@Component({
  selector: 'app-dlg-view-notice',
  standalone: true,
  imports: [
    CommonModule,
    NgTemplateOutlet,
    TimeBeforeComponent,
    InitialsPipe,
    MomentPipe,
    BtnBackComponent,
    BtnIconComponent,
    LoadingDotsComponent,
  ],
  templateUrl: './dlg-view-notice.component.html',
  styleUrl: './dlg-view-notice.component.css',
})
export class DlgViewNoticeComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly afs = inject(Firestore);
  private readonly dialogRef = inject(MatDialogRef<DlgViewNoticeComponent>, { optional: true });
  private readonly dialogData = inject<any>(MAT_DIALOG_DATA, { optional: true });

  noticeId: string | null = null;
  groupId: string | null = null;
  notice: Notice | null = null;
  loading = false;

  get isDialog(): boolean {
    return !!this.dialogRef;
  }

  onClose() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  ngOnInit() {
    this.groupId = this.dialogData?.groupId ?? this.route.snapshot.paramMap.get('id');
    this.noticeId = this.dialogData?.noticeId ?? this.route.snapshot.paramMap.get('noticeId');

    if (this.noticeId && this.groupId) {
      this.loading = true;
      const noticeDocRef = doc(
        this.afs,
        'groups',
        this.groupId,
        'notices',
        this.noticeId,
      );
      getDoc(noticeDocRef)
        .then((snap) => {
          this.loading = false;
          if (snap.exists()) {
            this.notice = { id: snap.id, ...snap.data() } as Notice;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error('Error fetching notice details:', err);
        });
    }
  }

  getSortedEvents(events: any): any[] {
    if (!events) return [];
    return Object.values(events).sort((a: any, b: any) => {
      const timeA = a.date?.toDate ? a.date.toDate().getTime() : 0;
      const timeB = b.date?.toDate ? b.date.toDate().getTime() : 0;
      return timeA - timeB;
    });
  }

  hasEvents(events: any): boolean {
    return events && Object.keys(events).length > 0;
  }
}
